import React from "react";
import LogIn from "../components/LogIn";

const LogInPage = () => {
  return (
    <div>
      <LogIn />
    </div>
  );
};

export default LogInPage;
